import Tree from 'rc-tree';
import type { EventDataNode } from 'rc-tree/lib/interface';
import React, { type Key, useState } from 'react';

import { ReactComponent as ThinArrowIcon } from '@assets/svg/thin-arrow.svg';

import type { ILocation } from '@model/structureData';

import {
  selectAllFacilitiesChecked,
  selectSubscrLocations,
  useSubscriptionsActions,
} from '../../store/useSubscriptionsProfileStore';
import style from './style.module.scss';

interface IProps {
  locations?: ILocation[];
}

interface ITreeSelectedInfo {
  event: 'select';
  selected: boolean;
  node: EventDataNode<ILocation>;
  selectedNodes: ILocation[];
  nativeEvent: MouseEvent;
}

const LocationSelectBlock: React.FC<IProps> = ({ locations }) => {
  const { setSubscrLocations } = useSubscriptionsActions();

  const [expandedKeys, setExpandedKeys] = useState<Key[]>([]);

  const userLocations: Array<number> = selectSubscrLocations();
  const allFacilitiesChecked = selectAllFacilitiesChecked();

  const onSelect = (selectedNodes: React.Key[], info: ITreeSelectedInfo) => {
    setSubscrLocations(selectedNodes, info.node.parentsIds, info.node);
  };

  return (
    <div className={style.selectBlock}>
      <Tree
        className={style.selectTree}
        treeData={locations}
        selectedKeys={userLocations}
        checkedKeys={userLocations}
        fieldNames={{
          children: 'children',
          title: 'name',
          key: 'id',
        }}
        showIcon={false}
        showLine={false}
        selectable={!allFacilitiesChecked}
        checkable={!!allFacilitiesChecked}
        disabled={!!allFacilitiesChecked}
        switcherIcon={<ThinArrowIcon />}
        expandedKeys={expandedKeys}
        onExpand={setExpandedKeys}
        onSelect={(selectedNodes, info) => onSelect(selectedNodes, info)}
      />
    </div>
  );
};

export default LocationSelectBlock;
